<template>
  <div class="dropdown">
    <button
      class="btn btn-default btn-sm dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="true"
    >
      <i class="fa fa-cog"></i>
      <span class="caret"></span>
    </button>
    <ul
      class="dropdown-menu dropdown-menu-right p-xs"
      aria-labelledby="dropdownMenu1"
    >
      <li v-for="check in checks" :key="check.key">
        <input-checkbox-boolean
          :model-value="check.activo"
          tipo="switch"
          @update:model-value="cambiarColumna(check, $event, true)"
        >
          {{ check.label }}
        </input-checkbox-boolean>
      </li>
      <li role="separator" class="divider"></li>
      <li>
        <a href="" @click.prevent="verNotificaciones">
          <i class="fa fa-bullhorn"></i>
          {{ labelNotificaciones }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import preferencias from '../../../../api/cuadernos/preferencias';

export default {
  props: {
    // Modelo CuadernoPreferencias
    model: { type: Object, required: true },
    urlNotificaciones: { type: String, required: true },
  },
  data() {
    return {
      notificacionesVisibles: false,
      checks: [
        {
          key: 'mostrar_nombre_alumno',
          label: this.$I18n.t('mostrar_nombre_alumno'),
          target: '.nombre-alumno',
          activo: true,
        },
        {
          key: 'mostrar_nota_media',
          label: this.$I18n.t('mostrar_nota_media'),
          target: '.col-nota-media',
          activo: false,
        },
        {
          key: 'mostrar_nota_final',
          label: this.$I18n.t('mostrar_nota_final'),
          target: '.col-nota-final',
          activo: true,
        },
        {
          key: 'mostrar_competencias',
          label: this.$I18n.t('mostrar_competencias'),
          target: '.col-informe-competencias',
          activo: true,
        },
      ],
    };
  },
  computed: {
    labelNotificaciones() {
      return this.$I18n.t(this.notificacionesVisibles ? 'ocultar_notificaciones' : 'Ver_notificaciones');
    },
  },
  mounted() {
    this.checks.forEach((check) => {
      if (this.model.preferencias[check.key] !== undefined) {
        check.activo = this.model.preferencias[check.key] === true;
      }
      this.cambiarColumna(check, check.activo);
    });
  },
  methods: {
    cambiarColumna(check, value, guardar = false) {
      check.activo = value;
      $(check.target).toggle(value);
      /* global ancho_competencias */
      ancho_competencias();
      if (guardar) {
        this.guardarCheckPreferencia(check);
      }
    },
    guardarCheckPreferencia(check) {
      const prefs = {};
      prefs[check.key] = check.activo;
      preferencias.guardar(
        this.model.cuaderno_profesor_id,
        'evaluaciones',
        prefs,
      );
    },
    // Código traído del antiguo cuaderno.js
    /* global $ */
    verNotificaciones() {
      if (!this.notificacionesVisibles) {
        $.get(this.urlNotificaciones, {}, (result) => {
          $.each(result, (key, value) => {
            const nodo = $(`#alumno-competencia-${key}`);
            if (nodo.length) {
              const iconoString = `<i class='icon-notificacion fa fa-bullhorn${value.clase_leido}' data-html='true' data-toggle='tooltip' title='' data-original-title='${value.title}'></i>`;
              const parser = new DOMParser();
              const doc = parser.parseFromString(iconoString, 'text/html');
              // Al cambiar a text/html nos devuelve un HTML: <html>...<body>
              // <i class="icon-notitification..."...</i></...
              const icono = doc.firstChild.lastChild.firstChild;

              nodo[0].parentNode.prepend(icono);
              this.notificacionesVisibles = true;
            }
          });
          return true;
        });
      } else {
        $('.icon-notificacion').each(function procesar() {
          const iIcon = $(this)[0];
          iIcon.parentNode.removeChild(iIcon);
        });
        this.notificacionesVisibles = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .dropdown-menu li {
    white-space: nowrap;
  }
</style>
